import { useLingui } from '@lingui/react/macro';
import { useCallback } from 'react';
import { BaseDialog, type DialogKey, useDialogStore } from '@/components/dialogs';
import { WithdrawPanel } from './components/withdraw_panel.tsx';

const DIALOG_KEY: DialogKey = 'withdrawDialog';

export function WithdrawCollateralDialog() {
  const { t } = useLingui();
  const isOpen = useDialogStore((state) => state.isDialogOpen(DIALOG_KEY));
  const close = useDialogStore((state) => state.closeDialog);

  const handleClose = useCallback(() => {
    close(DIALOG_KEY);
  }, [close]);

  return (
    <BaseDialog
      dialogKey={DIALOG_KEY}
      title={t({ comment: 'Withdraw dialog title', message: 'Withdraw' })}
      onClose={handleClose}
    >
      <WithdrawPanel isActive={isOpen} onClose={handleClose} />
    </BaseDialog>
  );
}
